/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createQuickBooksCompanyInfoResponse_CompanyInfoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type QuickBooksCompanyInfoResponse_CompanyInfo } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/quickbooks/companyinfo
 */
export interface CompanyinfoRequestBuilder extends BaseRequestBuilder<CompanyinfoRequestBuilder> {
    /**
     * Reads the name of the QuickBooks company this organization is connected to, straight from QuickBooks rather than from anything stored here — so a success also proves the connection is still good. An organization with no connection yet returns 404, as does one whose connection has been revoked at the QuickBooks end. Use it to show which company an administrator connected; for a plain yes-or-no check, the connection status endpoint answers without a 404.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<QuickBooksCompanyInfoResponse_CompanyInfo>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<QuickBooksCompanyInfoResponse_CompanyInfo | undefined>;
    /**
     * Reads the name of the QuickBooks company this organization is connected to, straight from QuickBooks rather than from anything stored here — so a success also proves the connection is still good. An organization with no connection yet returns 404, as does one whose connection has been revoked at the QuickBooks end. Use it to show which company an administrator connected; for a plain yes-or-no check, the connection status endpoint answers without a 404.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CompanyinfoRequestBuilderUriTemplate = "{+baseurl}/api/quickbooks/companyinfo";
/**
 * Metadata for all the requests in the request builder.
 */
export const CompanyinfoRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CompanyinfoRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createQuickBooksCompanyInfoResponse_CompanyInfoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
